import { ComponentProps, ElementType } from 'react';
import { NavLink } from 'react-router-dom';

import { ListItemProps, styled } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import { omitForwardedProps } from 'common/utils';

export type NavigationItemSize = 'small' | 'default';

type Props = ListItemProps & ComponentProps<typeof NavLink> & { component?: ElementType; size: NavigationItemSize };

export const NavigationItem = styled(ButtonBase, {
  shouldForwardProp: omitForwardedProps('size'),
})<Props>(({ theme: { palette, spacing, shape }, size }) => ({
  justifyContent: size === 'small' ? 'center' : 'start',
  display: 'flex',
  gap: spacing(1.5),
  alignItems: 'center',

  margin: spacing(0.25, 0),
  padding: spacing(0.75, 1),
  borderRadius: shape.borderRadius * 2,

  transition: 'all .2s cubic-bezier(.17,.67,.83,.67)',

  color: palette.grey[600],

  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
    color: 'inherit',
  },

  '&:hover': {
    backgroundColor: palette.grey[100],
  },

  '&:focus-visible': {
    backgroundColor: palette.grey[300],
    outline: 'none',
    '& svg': {
      color: palette.grey[600],
    },
  },

  '&.active': {
    color: palette.primary.main,
    background: palette.extendedPrimary[50],

    '&:hover': {
      backgroundColor: palette.extendedPrimary[100],
      color: palette.extendedPrimary[700],
    },

    '&:focus-visible': {
      backgroundColor: palette.extendedPrimary[300],
      color: palette.extendedPrimary[800],
      '& svg': {
        color: palette.extendedPrimary[800],
      },
    },
  },
}));
